export * from "./product-category";

export const PACKAGE_AMOUNT_MAX_LIMIT = 1_000_000;
export const PACKAGE_PRICE_MAX_LIMIT = 100_000_000_000;

/**
 * API Documentation tabs configuration
 * Define the tabs that will be shown in the API documentation modal
 */
export const API_DOCUMENTATION_TABS = [
  { value: "headers", translationKey: "tabs.headers" },
  { value: "body", translationKey: "tabs.body" },
  { value: "params", translationKey: "tabs.params" },
  { value: "responses", translationKey: "tabs.responses" }
] as const;

/**
 * Type for API documentation tab values
 */
export type ApiDocumentationTabValue =
  (typeof API_DOCUMENTATION_TABS)[number]["value"];
